import { render, staticRenderFns } from "./OnboardingSelect.vue?vue&type=template&id=09a81e55&scoped=true"
import script from "./OnboardingSelect.vue?vue&type=script&lang=js"
export * from "./OnboardingSelect.vue?vue&type=script&lang=js"
import style0 from "./OnboardingSelect.vue?vue&type=style&index=0&id=09a81e55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a81e55",
  null
  
)

export default component.exports